/*
 * This illustrates how to create a widget that makes use of a number of different field definition types.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

type Props = OwnProps;

export interface CustomLiveChatContainerStyles {
    container?: InjectableCss;
}

const styles: CustomLiveChatContainerStyles = {
    container: {
        css: css`
            margin: 30px 0 30px;
            text-align: center;
            border-width: 1px;
            border-style: solid;
            border-color: #ebedf2;
            font-size: 14px;
            padding: 30px 0;
            min-height: 220px;
            height: 100%;
            img {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                        max-width: 150px !important;
                        `,
                        css`
                        max-width: 140px;
                        `,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
};

export const CustomLiveChatContainerStyles = styles;

const CustomLiveChatContainer: React.FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="LiveChatContainer">
            <Zone contentId={id} zoneName="Content1" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CustomLiveChatContainer,
    definition: {
        displayName: "Live Chat Container",
        group: "Common",
    },
};

export default widgetModule;
